import React from "react";
import { Alert, Button } from "@mui/material";
import { useAgentProvider } from "../../hook/agentProvider";
import { ProviderRefusal as Refusal } from "../../connection/providerRefusal";

export const ProviderRefusal: React.FC<{ refusal: Refusal; onRestart: () => void; onDismiss?: () => void }> = ({
  refusal,
  onRestart,
  onDismiss,
}) => {
  const { switchChatProvider } = useAgentProvider();
  const switchToOpenRouter = () => {
    // The chat-level override (provider and model), then a new server session so the next message's session.create
    // carries it: a refused Session keeps the provider it was created with.
    switchChatProvider("openrouter");
    onRestart();
    onDismiss?.();
  };
  return (
    <Alert
      severity="warning"
      data-testid="provider-refusal"
      data-code={refusal.code}
      onClose={onDismiss}
    >
      {refusal.message}
      <Button size="small" data-testid="switch-to-openrouter" onClick={switchToOpenRouter}>
        Switch this chat to OpenRouter
      </Button>
    </Alert>
  );
};
